// extracted by mini-css-extract-plugin
export default {"ShipmentStatusRow":"ShipmentStatusRow-styles__ShipmentStatusRow__RZrM_","ShipmentStatusRow__badge_and_button":"ShipmentStatusRow-styles__ShipmentStatusRow__badge_and_button__OradP"};